import styled from 'styled-components';
import { truncateByLines } from '../../utilities/CssHelper';

export const StyledInfoBar = styled.div`
	padding: 20px;
    font-family: Poppin, sans-serif;
    background-color: ${props => props.backgroundColor || '#ECEDF2'};
    box-shadow: ${props => props.boxShadow || '0 3px 4px rgba(0, 0, 0, .2)'};
    border-radius: 2px;
    text-align: left;
    
    .title {
		color: #B2B2B2;
		margin-bottom: 5px;
    }
    
    .value {
    	color: #707070;
    	margin-bottom: 0px;
    	${truncateByLines(1)}
    }
`;
